// extracted by css-extract-rspack-plugin
export default {"meter":"LdKyTqynVsvT3iKB","rules":"vFkKA7nABk90gMj3","terms":"KQhYIRbJtFkzyq6Q","altAction":"VpW5yxaJLawyWjwR"};